import * as React from 'react';

import ReactGA from 'react-ga4';
import { withRouter, RouteComponentProps, useParams } from 'react-router';

import { logGAPageview } from '../util/log-ga';

let history: RouteComponentProps['history'];
let params: any;

// component which we will mount on top of the app
class BrowserHistorySpyComponent extends React.PureComponent<RouteComponentProps> {
  componentDidMount() {
    ({ history } = this.props);
    this.props.history.listen((location) => {
      ReactGA.set({ page: location.pathname });
      logGAPageview(location.pathname);
      Beacon('suggest');
    });
  }

  render() {
    return null;
  }
}

export const getHistory = () => history;
export const getParams = () => params;

export const BrowserHistorySpy = withRouter(BrowserHistorySpyComponent);
export const PathParamSpy = () => {
  params = useParams();
  return null;
};
